import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'
import { Search } from './Search'
import { SizingWidgetData } from '@helpers/products/sizingWidgetData'
import { EmptyObject } from 'types/helpers'

const ContactUs = dynamic(() => import('./ContactUs'))
const SizeChart = dynamic(() => import('./SizeChart'))
const SpokeFeedback = dynamic(() => import('./SpokeFeedback'))
const Unsubscribe = dynamic(() => import('./Unsubscribe'))
const Colors = dynamic(() => import('./Colors'))
const Returns = dynamic(() => import('@components/returns'))
const EndurosRange = dynamic(() => import('./EndurosRange'))

type StaticPageProps = {
  pagesHandle: string
  sizingWidgetData?: SizingWidgetData | EmptyObject
}
function StaticPages({ pagesHandle, sizingWidgetData }: StaticPageProps) {
  const router = useRouter()

  return (
    <>
      {/contact-us/.test(pagesHandle) && <ContactUs />}
      {/tops-size-chart|trousers-size-chart|shorts-size-chart|denim-size-chart|accessories-size-chart|underwear-size-chart/.test(
        pagesHandle
      ) && (
        <SizeChart
          router={router}
          pagesHandle={pagesHandle}
          sizingWidgetData={sizingWidgetData}
        />
      )}
      {/returns/.test(pagesHandle) && <Returns />}
      {/spoke-feedback/.test(pagesHandle) && <SpokeFeedback />}
      {/unsubscribe/.test(pagesHandle) && <Unsubscribe />}
      {/colors/.test(pagesHandle) && <Colors />}
      {/search/.test(pagesHandle) && <Search />}
      {/* Landing Pages */}
      {/enduros-range/.test(pagesHandle) && <EndurosRange />}
    </>
  )
}

export default StaticPages
